import { render, staticRenderFns } from "./ubruCoffee.vue?vue&type=template&id=b6fc4f28&scoped=true"
import script from "./ubruCoffee.vue?vue&type=script&lang=js"
export * from "./ubruCoffee.vue?vue&type=script&lang=js"
import style0 from "./ubruCoffee.vue?vue&type=style&index=0&id=b6fc4f28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6fc4f28",
  null
  
)

export default component.exports